import * as types from '../mutation-types'
import { api } from '@/modules/api/index'

export const state = {
  vipAttendeeTypes: {}
}

export const getters = {
  vipAttendeeTypes: state => state.vipAttendeeTypes
}

export const actions = {
  async getVipAttendeeTypes ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.vipAttendeeType.get())
      commit(types.SET_VIP_ATTENDEE_TYPE, data)
      return data
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'VIP attendee types weren\'t fetched')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async addVipAttendeeTypes ({ commit }, newRegular) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = this.$axios.post(api.vipAttendeeType.addVipAttendeeTypes(), { ...newRegular })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Regular attendee type was added successfully')
      return response
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'VIP attendee type wasn\'t added')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editVipAttendeeTypes ({ commit }, editRegular) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.put(api.vipAttendeeType.editVipAttendeeTypes(), { ...editRegular })
      commit(types.CREATE_SUCCESS_MESSAGE, 'VIP attendee type was edited successfully')
      return response
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'VIP attendee type wasn\'t edited')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteVipAttendeeTypes ({ commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios(
        { method: 'delete', url: api.vipAttendeeType.deleteVipAttendeeTypes(id) })
      commit(types.CREATE_SUCCESS_MESSAGE, 'VIP attendee type was deleted successfully')
      return response
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'VIP attendee type wasn\'t deleted')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

export const mutations = {
  [types.SET_VIP_ATTENDEE_TYPE] (state, { attendeeTypes }) {
    state.vipAttendeeTypes = [...attendeeTypes]
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/vipAttendeeSettings.js